export const darken = (hex: string, percent: number): string => {
  // strip the leading # if it's there
  let mappedHex = hex.replace(/^\s*#|\s*$/g, '');

  // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
  if (mappedHex.length === 3) {
    mappedHex = mappedHex.replace(/(.)/g, '$1$1');
  }

  const r = parseInt(mappedHex.substr(0, 2), 16);
  const g = parseInt(mappedHex.substr(2, 2), 16);
  const b = parseInt(mappedHex.substr(4, 2), 16);

  return `#${
    // eslint-disable-next-line no-bitwise
    ((0 | (1 << 8) + r * (1 - percent / 100)).toString(16)).substr(1)
    // eslint-disable-next-line no-bitwise
  }${((0 | (1 << 8) + g * (1 - percent / 100)).toString(16)).substr(1)
    // eslint-disable-next-line no-bitwise
  }${((0 | (1 << 8) + b * (1 - percent / 100)).toString(16)).substr(1)}`;
};
